import React, { useEffect, useState } from "react";
import { FaFacebookF, FaThList, FaLinkedin } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { RiMenu4Fill } from "react-icons/ri";
import {
  AiFillHeart,
  AiFillShopping,
  AiFillInstagram,
  AiOutlineWhatsApp,
} from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_card_products,
  get_wishlist_products,
} from "../store/reducers/cardReducer";

const Headers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );

  const { pathname } = useLocation();
  const [showShidebar, setShowShidebar] = useState(true);
  const redirect_card_page = () => {
    if (userInfo) {
      navigate(`/card`);
    } else {
      navigate(`/login`);
    }
  };

  useEffect(() => {
    if (userInfo) {
      dispatch(get_card_products(userInfo.id));
      dispatch(get_wishlist_products(userInfo.id));
    }
  }, [userInfo]);
  return (
    <div className="w-full relative z-50 bg-slate-100/50 backdrop-blur-md shadow-md">
      <div className="w-white">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="h-[80px] md-lg:h-[60px] flex justify-between items-center flex-wrap">
            <div className="md-lg:w-full w-3/12 md-lg:pt-2">
              <div className="flex justify-between items-center">
                <Link to="/">
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}/images/logo.png`}
                    alt="logo"
                    className="w-[180px] sm:w-[140px]"
                  />
                </Link>
                <div
                  className="justify-center items-center w-[35px] h-[35px] text-2xl text-mainColor   cursor-pointer lg:hidden md-lg:flex xl:hidden hidden"
                  onClick={() => setShowShidebar(false)}
                >
                  <span>
                    <RiMenu4Fill />
                  </span>
                </div>
              </div>
            </div>
            <div className="md-lg:w-full w-9/12">
              <div className="flex justify-between md-lg:justify-center items-center flex-wrap pl-8">
                <ul className="flex justify-start items-start gap-8 text-sm font-bold uppercase md-lg:hidden">
                  <li>
                    <Link
                      to="/"
                      className={`p-2 block ${
                        pathname === "/" ? "text-thirdColor" : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      الرئيسية
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/doctors"
                      className={`p-2 block ${
                        pathname === "/doctors"
                          ? "text-thirdColor"
                          : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      الاطباء
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-products"
                      className={`p-2 block ${
                        pathname === "/our-products"
                          ? "text-thirdColor"
                          : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      المتجر
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/blogs"
                      className={`p-2 block ${
                        pathname === "/blogs"
                          ? "text-thirdColor"
                          : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      المقالات
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className={`p-2 block ${
                        pathname === "/about"
                          ? "text-thirdColor"
                          : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      من نحن
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className={`p-2 block ${
                        pathname === "/contact"
                          ? "text-thirdColor"
                          : "text-slate-600"
                      }`}
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      اتصل بنا
                    </Link>
                  </li>
                </ul>
                <div className="flex md-lg:hidden justify-center items-center gap-5">
                  <div className="flex justify-center gap-5">
                    {/* <div
                      onClick={() =>
                        navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
                      }
                      className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] round-btn"
                    >
                      <span className="text-xl">
                        <AiFillHeart />
                      </span>
                      {wishlist_count !== 0 && (
                        <div className="w-[20px] h-[20px] absolute bg-green-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                          {wishlist_count}
                        </div>
                      )}
                    </div> */}
                    <div
                      onClick={redirect_card_page}
                      className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] round-btn"
                    >
                      <span className="text-xl">
                        <AiFillShopping />
                      </span>
                      {card_product_count !== 0 && (
                        <div className="w-[20px] h-[20px] absolute bg-mainColor rounded-full text-red-600 flex justify-center items-center -top-[3px] -right-[5px]">
                          {card_product_count}
                        </div>
                      )}
                    </div>
                  </div>
                  {userInfo ? (
                    <Link
                      className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                      to="/dashboard"
                    >
                      <span>
                        <FaThList />
                      </span>
                      <span>{userInfo.name}</span>
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="flex cursor-pointer justify-center items-center gap-2 text-md text-slate-600"
                    >
                      <span>
                        <FiLogIn className="round-btn w-9 h-9 text-sm" />
                      </span>
                      <span>تسجيل الدخول </span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md-lg:block">
        <div
          onClick={() => setShowShidebar(true)}
          className={`fixed duration-200 transition-all ${
            showShidebar ? "invisible" : "visible"
          } hidden md-lg:block w-screen h-screen bg-[rgba(0,0,0,0.5)] top-0 left-0 z-20`}
        ></div>
        <div
          className={`w-[300px] z-[9999] transition-all duration-200 fixed  ${
            showShidebar ? "-left-[300px]" : "left-0"
          } top-0 overflow-y-auto h-screen py-6 px-8 bg-cover bg-no-repeat bg-right`}
          style={{
            backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/sidebg.png)`,
          }}
        >
          <div className="flex justify-start flex-col gap-6">
            <Link to="/">
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}/images/logo.png`}
                alt="logo"
              />
            </Link>
            <div className="flex justify-star items-center gap-10">
              {userInfo ? (
                <Link
                  className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                  to="/dashboard"
                >
                  <span>
                    <FaThList />
                  </span>
                  <span>{userInfo.name}</span>
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="flex cursor-pointer justify-center items-center gap-2 text-md text-slate-600 "
                >
                  <span>
                    <FiLogIn className="round-btn w-9 h-9 text-sm" />
                  </span>
                  <span className="text-fourthColor">تسجيل الدخول </span>
                </Link>
              )}
            </div>
            <ul className="flex flex-col justify-start items-start  text-md font-semibold uppercase">
              <li>
                <Link
                  to="/"
                  className={`py-2 block ${
                    pathname === "/"
                      ? "text-fourthColor drop-shadow-xs "
                      : "text-slate-600"
                  }`}
                >
                  Accueil - الرئيسية
                </Link>
              </li>
              <li>
                <Link
                  to="/doctors"
                  className={`py-2 block ${
                    pathname === "/doctors"
                      ? "text-fourthColor"
                      : "text-slate-600"
                  }`}
                >
                  Doctors - الأطباء
                </Link>
              </li>
              <li>
                <Link
                  to="/our-products"
                  className={`p-2 block ${
                    pathname === "/our-products"
                      ? "text-fourthColor"
                      : "text-slate-600"
                  }`}
                >
                  Produits - منتجات
                </Link>
              </li>
              <li>
                <Link
                  to="/blogs"
                  className={`py-2 block ${
                    pathname === "/blogs"
                      ? "text-fourthColor "
                      : "text-slate-600"
                  }`}
                >
                  Blogs - المقالات
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className={`py-2 block ${
                    pathname === "/about"
                      ? "text-fourthColor"
                      : "text-slate-600"
                  }`}
                >
                  A Propos - معلومات عنا
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={`py-2 block ${
                    pathname === "/contact"
                      ? "text-fourthColor"
                      : "text-slate-600"
                  }`}
                >
                  Contact - اتصال
                </Link>
              </li>
            </ul>
            <ul className="flex justify-start items-center gap-3">
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  href="https://www.facebook.com/profile.php?id=100094522181755&mibextid=ZbWKwL"
                  target="_blank"
                >
                  <FaFacebookF />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  href="https://www.instagram.com/tabbibi360?igsh=MXA3Z2VkZHQ1b3ZvYw=="
                  target="_blank"
                >
                  <AiFillInstagram />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  href="https://wa.me/qr/4RIJE7RR7MEUH1"
                  target="_blank"
                >
                  <AiOutlineWhatsApp />
                </Link>
              </li>
              <li>
                <Link
                  className="w-[32px] h-[32px] flex justify-center items-center round-btn"
                  href="https://www.linkedin.com/in/tabbibi-com-1a181b304?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                >
                  <FaLinkedin />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Headers;
